// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: "https://admin-api-dev.ezyagric.com",
  PROF_API: "https://login-api-dev.ezyagric.com",
  NOTIFY_API: "https://nortify-api-dev.ezyagric.com/api/v2/notify",
  CREDIT_AGG: "https://aggregator-api-dev.ezyagric.com",
  DASH_API_URL: "https://admin-api-dev.ezyagric.com/api/v1",
  API_URL_V2: "https://admin-api-dev.ezyagric.com/api/v2",
  // API_URL_V3: "http://192.168.43.102:5005",
  API_URL_V3: "https://admin-portal-api.ezyagric.com",
  FRONTED_URL: "http://localhost:4200/",

  API_URL_NOTIFICATION: "https://fcm.googleapis.com/fcm/send",

  GOOGLE_MAPS_KEY: "AIzaSyCyp-1ODJTfdQAEnr5qI9iz0ZsiPB1YWsM",

  firebaseConfig: {
    agent: {
      apiKey: "AIzaSyDd4PcBPu6QDAiFgC0Ty7r_m0Zvh37xZao",
      authDomain: "ezyagric-agentapp.firebaseapp.com",
      databaseURL: "https://ezyagric-agentapp.firebaseio.com",
      projectId: "ezyagric-agentapp",
      storageBucket: "ezyagric-agentapp.appspot.com",
      messagingSenderId: "165160255047",
      appId: "1:165160255047:web:307bab16bcb78d151ffb62",
      measurementId: "G-CD2YLMS0VL",
    },
    farmer: {
      apiKey: "AIzaSyCyp-1ODJTfdQAEnr5qI9iz0ZsiPB1YWsM",
      authDomain: "ezyagric-farmer.firebaseapp.com",
      databaseURL: "https://ezyagric-farmer.firebaseio.com",
      projectId: "ezyagric-farmer",
      storageBucket: "ezyagric-farmer.appspot.com",
      messagingSenderId: "779664112971",
      appId: "1:779664112971:web:26efe5be2c633c5857bcce",
      measurementId: "G-895B9PEMYM",
    },
    farmerFlutter: {
      apiKey: "AIzaSyACWDQzCwGgKAZtKjRdDUuMowWkVzPGThA",
      authDomain: "farmerflutter-84a53.firebaseapp.com",
      databaseURL: "https://farmerflutter-84a53-default-rtdb.firebaseio.com",
      projectId: "farmerflutter-84a53",
      storageBucket: "farmerflutter-84a53.firebasestorage.app",
      messagingSenderId: "472202435090",
      appId: "1:472202435090:web:b84d697958c5928f3d96cb",
      measurementId: "G-5PGSGCR3MS",
    },
  },
  firebaseNodes: {
    agrishop: "agrishop_test",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
